import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-ambulance',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './ambulance.component.html',
  styleUrl: './ambulance.component.css'
})
export class AmbulanceComponent {

}
